import { useContextAwareGetModuleTypes } from '@app/hooks/useGenericOperationsHooks';
import { ModuleTypeRegistry } from './moduleTypeRegistry';
import { ModuleType } from '@typedefs/interfaces';

// The registry is filled by the getModuleTypes query itself (see
// createGenericOperationsApi), so it is ready whenever `moduleTypes` is defined.
export const useModuleTypeRegistry = () => {
  const { data: moduleTypes, isLoading, error } = useContextAwareGetModuleTypes({});

  return {
    moduleTypes: moduleTypes as ModuleType[],
    isLoading,
    error,
    registry: ModuleTypeRegistry.getInstance()
  };
};
